import { useEffect, useState } from "react";
import { api, formatError, formatNZD, imageUrl } from "@/lib/api";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";

export default function RegionAdverts({ region, tick, onChange }) {
  const [items, setItems] = useState([]);
  const load = async () => {
    try { const { data } = await api.get("/staff/markdowns", { params: { region } }); setItems(data); }
    catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, [region, tick]);
  const remove = async (m) => {
    if (!window.confirm(`Remove "${m.product_name}" from ${m.store?.store_name}? It will no longer show to shoppers.`)) return;
    try { await api.delete(`/staff/markdowns/${m.id}`); toast.success("Advert removed"); onChange?.(); }
    catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  return (
    <Card data-testid="op-adverts-card">
      <CardHeader>
        <CardTitle className="font-display text-xl">Live adverts ({items.length})</CardTitle>
        <CardDescription>Remove anything misleading or against the rules.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2 max-h-[480px] overflow-auto">
        {items.length === 0 && <div className="text-sm text-slate-500">No live adverts right now.</div>}
        {items.map((m) => (
          <div key={m.id} className="flex items-center gap-3 border border-slate-200 rounded-xl p-2" data-testid={`op-advert-${m.id}`}>
            <img src={imageUrl(m.image_path)} alt="" className="w-12 h-12 rounded-lg object-cover bg-slate-100" />
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-sm truncate">{m.product_name}</div>
              <div className="text-xs text-slate-500 truncate">{m.store?.store_name} · {formatNZD(m.now_price)} (was {formatNZD(m.was_price)})</div>
            </div>
            <Button size="sm" variant="outline" className="text-red-700 border-red-200" onClick={() => remove(m)} data-testid={`op-remove-${m.id}`}><Trash2 className="w-4 h-4" /></Button>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
